module.exports = __webpack_public_path__ + "static/img/1.a88354e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/1.jpg
// module id = LPcp
// module chunks = 12